import React from 'react'

import './styles/typography.scss'

const colorCssMap = {
    primary: 'typo-primary',
    secondary: 'typo-secondary',
    error: 'typo-error',
    warning: 'typo-warning',
    white: 'typo-white',
    grey: 'typo-grey',
}

const Typography = ({
    type, color, style, cssClass, children,
}) => {
    switch (type) {
        case 'p':
            return <p className={`${colorCssMap[color]} ${cssClass}`} style={style}>{children}</p>
        case 'b':
            return <b className={`${colorCssMap[color]} ${cssClass}`} style={style}>{children}</b>
        case 'h4':
            return <h4 className={`${colorCssMap[color]} ${cssClass}`} style={style}>{children}</h4>
        case 'h3':
            return <h3 className={`${colorCssMap[color]} ${cssClass}`} style={style}>{children}</h3>
        case 'h2':
            return <h2 className={`${colorCssMap[color]} ${cssClass}`} style={style}>{children}</h2>
        case 'tiny':
            return <p className={`tiny-typography ${colorCssMap[color]} ${cssClass}`} style={style}>{children}</p>
        case 'tiniest':
            return <p className={`tiniest-typography ${colorCssMap[color]} ${cssClass}`} style={style}>{children}</p>
        default:
            return <p className={`${colorCssMap[color]} ${cssClass}`} style={style}>{children}</p>
    }
}

export default Typography
